const PERMISSIONS_AGGREGATOR_PAGE = {
    VIEW: 'voucher_fulfillment_aggregator::get',
    EDIT: 'voucher_fulfillment_aggregator::update'
} as const;

export default PERMISSIONS_AGGREGATOR_PAGE;